module.exports = __webpack_public_path__ + "img/reserveNumberRight.dfbb8992.svg";